import { useLayoutEffect, useState } from 'react'

/** Portal target next to AppTabBar for the active record's commands / toggle. */
export const WORKSPACE_TAB_CHROME_ID = 'workspace-tab-chrome'

export function useWorkspaceTabChromeHost(): HTMLElement | null {
  const [host, setHost] = useState<HTMLElement | null>(() =>
    typeof document !== 'undefined' ? document.getElementById(WORKSPACE_TAB_CHROME_ID) : null,
  )
  useLayoutEffect(() => {
    const sync = () => {
      setHost(document.getElementById(WORKSPACE_TAB_CHROME_ID))
    }
    sync()
    const root = document.body
    const observer = new MutationObserver(sync)
    observer.observe(root, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [])
  return host
}
